import objectFitVideos from 'object-fit-videos';
import enableInlineVideo from 'iphone-inline-video';
import $ from 'jquery';

function initObjectFitVideos() {
	const videos = document.querySelectorAll('video.object-fit--cover');
	if (videos) {
		objectFitVideos(videos);
	}
}

document.addEventListener('DOMContentLoaded', initObjectFitVideos);

// or if you have multiple videos:
$('video').each(
	function () {
		$(this).attr('playsinline', '');
		enableInlineVideo(this);
	},
);
